//トップページ
export function homeFunc() {
}

const menuSwiper = new Swiper('.js-menu-slide', {
  loop: true,
  slidesPerView: 'auto',
  spaceBetween: 14,
  speed: 1500,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
  breakpoints: {
    768: {
      spaceBetween: 40,
    }
  }
});

const mainSwiper = new Swiper('.js-main-slide', {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 40,
  speed: 1500,
  navigation: {
    nextEl: '.p-home-works-main .swiper-button-next',
    prevEl: '.p-home-works-main .swiper-button-prev',
  },
  breakpoints: {
    768: {
      slidesPerView: 1.2,
      centeredSlides: true,
    }
  },
  thumbs: {
    swiper: menuSwiper,
  },
});

const cardSwiper = new Swiper('.js-card-slide', {
  // loop: true,
  slidesPerView: 1,
  spaceBetween: 40,
  speed: 1500,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
  pagination: {
    el: '.p-home-cards__slider .swiper-pagination',
    clickable: true,
  },
  breakpoints: {
    768: {
      slidesPerView: 1.2,
    }
  },
});

const requirementsSwiper = new Swiper('.js-requirements-slide', {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 50,
  centeredSlides: true,
  speed: 1500,
  navigation: {
    nextEl: '.p-home-requirements .swiper-button-next',
    prevEl: '.p-home-requirements .swiper-button-prev',
  },
  breakpoints: {
    768: {
      slidesPerView: 1.5,
    },
    1366: {
      slidesPerView: 2.6,
    },
  },
});